import React, { useState, useEffect } from "react";
import {
  PostApi,
  GetApi,
  getProfCliente,
  getDocCliente,
  getDados,
  logout
} from "../../services/auth.js";
import { NavbarSticky, NavbarContainer, Container, Dropdown, Navbar, Section, Grid, InputContainer, FormLabel, Textarea} from 'uikit-react';

import { toggleNav, MudaVisibilidade } from "../../services/funcoes";

import { Modal, ModalBody, ModalHeader, ModalFooter } from "../../componentes/ModalLegacy";
import Visibility from "@material-ui/icons/Visibility";
import { FaKey } from "react-icons/fa";
import VisibilityOff from "@material-ui/icons/VisibilityOff";
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import Swal from "sweetalert2";

import { Content, DivVerificaSenha, BtMostraSenha } from "./styles";
import Logo from "../../assets/imagens/logo_de_grao_em_pao_branco.png"
import User from "../../assets/imagens/no_image.jpg"

const nomeUser = localStorage.getItem('nomeUser')

export function Header() {

  let user = getDados()
  const [cpf, setCpf] = useState("");

  // TROCA SENHA 
  const [modalTrocaSenha, setModalTrocaSenha] = useState(false);
  const [SenhaAtual, setSenhaAtual] = useState("");
  const [NovaSenha, setNovaSenha] = useState("");
  const [ConfirmaSenha, setConfirmaSenha] = useState("");
  const [ShowPasswordEsqueceu, setShowPasswordEsqueceu] = useState(false);
  const [ShowPasswordEsqueceu2, setShowPasswordEsqueceu2] = useState(false);
  const [ShowPasswordEsqueceu3, setShowPasswordEsqueceu3] = useState(false);
  const [testeSenhaMaius, SettesteSenhaMaius] = useState("dng");
  const [testeSenhaMinus, SettesteSenhaMinus] = useState("dng");
  const [testeSenhaEsp, SettesteSenhaEsp] = useState("dng");
  const [testeSenhaQtd, SettesteSenhaQtd] = useState("dng");
  const [testeSenhaNum, SettesteSenhaNum] = useState("dng");
  const [senhaOk, SetsenhaOk] = useState(false);

    const TesteSenha = (id) => {
    return <>
    <DivVerificaSenha id={id}>
      <div className={testeSenhaMaius}> {testeSenhaMaius === "dng" ? <ErrorOutlineIcon /> : <CheckCircleOutlineIcon />} Letra maiúscula </div>
      <div className={testeSenhaMinus}> {testeSenhaMinus === "dng" ? <ErrorOutlineIcon /> : <CheckCircleOutlineIcon />} Letra minúscula </div>
      <div className={testeSenhaEsp}> {testeSenhaEsp === "dng" ? <ErrorOutlineIcon /> : <CheckCircleOutlineIcon />} Caractere especial </div>
      <div className={testeSenhaNum}> {testeSenhaNum === "dng" ? <ErrorOutlineIcon /> : <CheckCircleOutlineIcon />} Número </div>
      <div className={testeSenhaQtd}> {testeSenhaQtd === "dng" ? <ErrorOutlineIcon /> : <CheckCircleOutlineIcon />} Mínimo de 8 caracteres </div>
    </DivVerificaSenha>
    </>
  }

  const alteraSenha = async () => {

    if ( SenhaAtual == "" || SenhaAtual == null ) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        html: "Você precisa informar a senha atual!",
      });
      return;
    }
    
    if ( testeSenhaMaius !== "scs" || testeSenhaMinus !== "scs" || testeSenhaEsp !== "scs" || testeSenhaQtd !== "scs" || testeSenhaNum !== "scs" ) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        html: "Preencha os campos de senha conforme os requisitos.",
      });
      return;
    }
    if ( NovaSenha !== ConfirmaSenha ) {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        html: "As senhas não coincidem!",
      });
      return;
    }

    MudaVisibilidade('btn-fechar-troca-senha');
    MudaVisibilidade('btn-alterar-senha');
    MudaVisibilidade('btn-alterar-senha-loading');

    const dados = {
      "userAtualPassword": SenhaAtual,
      "userId": cpf,
      "userPassword": NovaSenha
    }
  
    const resultados = await PostApi("GenLogin/NovaSenha", dados); 
    if (resultados.data.sucesso) {
      
      Swal.fire({
        icon: "success",
        title: "Sucesso!",
        html: "Senha alterada com sucesso.",
        confirmButtonText: "OK",
      }).then(async (result) => {
        if (result.isConfirmed) {
          setModalTrocaSenha(false);
        }
      });
    } else {
      Swal.fire({
        icon: "warning",
        title: "Atenção!",
        html: resultados.data.mensagem,
      });
    }

    MudaVisibilidade('btn-fechar-troca-senha');
    MudaVisibilidade('btn-alterar-senha');
    MudaVisibilidade('btn-alterar-senha-loading');
  };

  const testaSenha = (senha) => {
    let teste = true;
    let letrasMaiusculas = /[A-Z]/;
    let letrasMinusculas = /[a-z]/;
    let numeros = /[0-9]/;
    let caracteresEspeciais = /[!|@|#|$|%|^|&|*|(|)|-|_]/;

    if (caracteresEspeciais.test(senha)) {
      SettesteSenhaEsp("scs");
    } else {
      SettesteSenhaEsp("dng");
      teste = false;
    }
    if (numeros.test(senha)) {
      SettesteSenhaNum("scs");
    } else {
      SettesteSenhaNum("dng");
      teste = false;
    }
    if (letrasMaiusculas.test(senha)) {
      SettesteSenhaMaius("scs");
    } else {
      SettesteSenhaMaius("dng");
      teste = false;
    }
    if (letrasMinusculas.test(senha)) {
      SettesteSenhaMinus("scs");
    } else {
      SettesteSenhaMinus("dng");
      teste = false;
    }
    if (senha.length > 7) {
      SettesteSenhaQtd("scs");
    } else {
      SettesteSenhaQtd("dng");
      teste = false;
    }

    SetsenhaOk(teste);
  };

  const LogAcesso = async () => {
    const cpf = await getDocCliente();
    const dadosLog = {
      documento: cpf,
      origem: 1072,
      url: window.location.pathname,
    };
    const retorno = await PostApi("LogAcesso/Salva", dadosLog);
    if (retorno.data.sucesso) {
      console.log("Log de acesso salvo com sucesso");
    } else {
      console.log("Erro ao salvar log de acesso");
    }
  }

  useEffect(() => {
    LogAcesso();
    setCpf(getDocCliente().replace(/\D/g, ""));
  }, []);

    return (
      <>
      <Content>
         <Container size="expand" Sticky="" className="uk-navbar-container tm-navbar-container uk-active">
          <Section className="uk-container uk-container-expand">
            <NavbarSticky>
              <NavbarContainer style={{ backgroundColor: '#043C5A' }} >
                <Navbar className="uk-navbar-left" >      
                  <a 
                      id="sidebar_toggle" 
                      className="uk-navbar-toggle"
                      onClick={() => {
                        toggleNav("sidebar", "uk-left-menu-inative");
                      }}
                      href="#!"                          
                    >
                      <span uk-icon="icon: menu"></span>
                    </a>
                    <div className="uk-grid-small uk-flex-middle uk-flex-center uk-grid">
                      <div className="uk-width-auto uk-first-column">                                
                          <img src={Logo} style={{width: '80px'}} alt="De Grão em Pão"/>
                      </div>
                      {/* <div className="uk-width-auto uk-text-left mobile">
                          <h6 className="uk-margin-remove-bottom uk-text-uppercase uk-text-bold uk-light">De Grão em Pão</h6> 
                          <p style={{ color: '#ffff' }}  className="uk-text-meta uk-margin-remove-top">Painel Administrativo</p>
                      </div> */}
                    </div>   
                </Navbar>

                <Navbar className="uk-navbar-right uk-light uk-margin-right">
                    <ul className="uk-navbar-nav">
                      <li className="uk-active">                              
                        <Container>
                            <a> 
                              <img src={User} width="40" className="uk-border-circle"  alt=""/> &nbsp;
                              <span uk-icon="icon: chevron-down"></span>
                            </a>                                      
                            <Dropdown>
                              <ul className="uk-nav uk-navbar-dropdown-nav">
                                  <li className="uk-nav-header">{nomeUser}</li>                                         
                                  <li className="uk-nav-divider"></li>           
                                  <li><a onClick={() => setModalTrocaSenha(true)}>Alterar senha</a></li>                                
                                  <li><a onClick={() => logout()}>Sair</a></li>                                
                              </ul>
                            </Dropdown>
                          </Container> 
                      </li>
                    </ul>
                  </Navbar>       
              </NavbarContainer>
            </NavbarSticky>
          </Section>
         </Container>
      {/* MODAL TROCA SENHA*/}
      <Modal
        isOpen={modalTrocaSenha}
        id="sm"
        centered
        onClose={() => setModalTrocaSenha(false)}
        style={{ textAlign: "left" }}
      >
        <ModalHeader>
          Trocar Minha Senha
        </ModalHeader>

        <ModalBody>

          <Grid className="uk-grid-small">

            {/* Senha Atual */}
            <Section className="uk-width-1-1@m">
              <InputContainer style={{position: 'relative'}}>
                <FormLabel className="uk-form-label">Informe sua senha atual <span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Senha Atual'
                  type={ShowPasswordEsqueceu ? "text" : "password"}
                  value={SenhaAtual}
                  onChange={e => setSenhaAtual(e.target.value)}
                />
                 { ShowPasswordEsqueceu ? (
                  <BtMostraSenha onClick={() => setShowPasswordEsqueceu(!ShowPasswordEsqueceu)}> <Visibility /> </BtMostraSenha>
                ) : (
                  <BtMostraSenha onClick={() => setShowPasswordEsqueceu(!ShowPasswordEsqueceu)}> <VisibilityOff /> </BtMostraSenha>
                )}
              </InputContainer>
            </Section>

             {/* Nova Senha */}
             <Section className="uk-width-1-1@m">
              <InputContainer style={{position: 'relative'}}>
                <FormLabel className="uk-form-label">Nova Senha<span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Nova Senha'
                  type={ShowPasswordEsqueceu2 ? "text" : "password"}
                  value={NovaSenha}
                  onChange={e => {setNovaSenha(e.target.value); testaSenha(e.target.value)}}
                  onFocus={() => MudaVisibilidade("Senha")}
                  onBlur={() => MudaVisibilidade("Senha")}
                />
                { ShowPasswordEsqueceu2 ? (
                  <BtMostraSenha onClick={() => setShowPasswordEsqueceu2(!ShowPasswordEsqueceu2)}> <Visibility /> </BtMostraSenha>
                ) : (
                  <BtMostraSenha onClick={() => setShowPasswordEsqueceu2(!ShowPasswordEsqueceu2)}> <VisibilityOff /> </BtMostraSenha>
                )}
              </InputContainer>
              {TesteSenha('Senha')}
            </Section>

            {/* Confirmação Nova Senha */}
            <Section className="uk-width-1-1@m">
              <InputContainer style={{position: 'relative'}}>
                <FormLabel className="uk-form-label">Confirmar a Nova Senha<span className="uk-text-danger">*</span></FormLabel>
                <input
                  className="uk-input input"
                  placeholder='Confirmar a Nova Senha'
                  type={ShowPasswordEsqueceu3 ? "text" : "password"}
                  value={ConfirmaSenha}
                  onChange={e => setConfirmaSenha(e.target.value)}
                />
                { ShowPasswordEsqueceu3 ? (
                  <BtMostraSenha onClick={() => setShowPasswordEsqueceu3(!ShowPasswordEsqueceu3)}> <Visibility /> </BtMostraSenha>
                ) : (
                  <BtMostraSenha onClick={() => setShowPasswordEsqueceu3(!ShowPasswordEsqueceu3)}> <VisibilityOff /> </BtMostraSenha>
                )}
              </InputContainer>
            </Section>

          </Grid>
        </ModalBody>

        <ModalFooter>
          <Grid className="uk-grid-small uk-flex uk-flex-right">
            <Section>
              <button
                type="button"
                id='btn-fechar-troca-senha'
                className="uk-button uk-button-danger"
                onClick={() => setModalTrocaSenha(false)}
              >
                <span uk-icon="icon: close"></span> Fechar
              </button>
            </Section>
            <Section>
              <button
                type="button"
                id="btn-alterar-senha"
                className="uk-button uk-button-primary"
                onClick={() => alteraSenha()}
              >
                Alterar senha
              </button>

              <button className="uk-button uk-button-primary" id="btn-alterar-senha-loading" >
                <span uk-spinner="ratio: 0.5" className="uk-margin-small-right"></span> Aguarde
              </button>
            </Section>
          </Grid>
        </ModalFooter>
      </Modal>  
      </Content>


      </>
    );
  }

